var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex special-wrap",class:{'rightBackground': _vm.index%2 == 0}},[_c('div',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(this.title))]),_c('div',{staticStyle:{"color":"#2FFAFF"}},[(_vm.isOnline)?_c('b',[_vm._v(_vm._s(_vm._f("formatterValue")(_vm.startValue))+" "+_vm._s(this.unit))]):_c('b',[_vm._v("待上线")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }